/**
 * WP-12 F/S counter — the loving homage to the original's frames-per-second
 * readout in the bottom-right corner. Off by default (save.ts getFps); since
 * goldens boot with fresh localStorage and the counter is a fixed-position
 * sibling of the canvas (outside element-scoped screenshots), it never perturbs
 * a golden. The rAF loop only runs while shown.
 */
const CSS = `
#ar-fps { position: fixed; right: 6px; bottom: 5px; z-index: 8000; pointer-events: none;
  font-family: 'Courier New', monospace; font-size: 12px; font-weight: 700; color: hsl(131, 76.4%, 75.1%);
  background: hsla(0, 0%, 0%, 0.55); padding: 2px 7px; border-radius: 4px;
  letter-spacing: 0.5px; display: none; }
#ar-fps.on { display: block; }
`;

let el: HTMLElement | null = null;
let raf = 0;
let frames = 0;
let last = 0;
let shown = '0';

function loop(now: number): void {
  frames++;
  if (now - last >= 500) {
    shown = String(Math.round((frames * 1000) / (now - last)));
    if (el) el.textContent = `FPS: ${shown}`;
    frames = 0;
    last = now;
  }
  raf = requestAnimationFrame(loop);
}

/** Show or hide the F/S counter (starting/stopping its rAF loop). */
export function showFps(on: boolean): void {
  if (!document.getElementById('ar-fps-style')) {
    const style = document.createElement('style');
    style.id = 'ar-fps-style';
    style.textContent = CSS;
    document.head.appendChild(style);
  }
  if (!el) {
    el = document.createElement('div');
    el.id = 'ar-fps';
    el.textContent = 'FPS: --';
    document.body.appendChild(el);
  }
  el.classList.toggle('on', on);
  if (on && !raf) {
    last = performance.now();
    frames = 0;
    raf = requestAnimationFrame(loop);
  } else if (!on && raf) {
    cancelAnimationFrame(raf);
    raf = 0;
  }
}
